import { render, staticRenderFns } from "./action-page.vue?vue&type=template&id=57a68ada&scoped=true&"
import script from "./action-page.vue?vue&type=script&lang=js&"
export * from "./action-page.vue?vue&type=script&lang=js&"
import style0 from "./action-page.vue?vue&type=style&index=0&id=57a68ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a68ada",
  null
  
)

export default component.exports